import React, { useState } from "react";
import { Modal, message } from "antd";
import Base64 from "../../utils/base64";
import dashboardIcon from "../../assets/images/dashboard.png";
import ROUTES from "../../config/routes";
import axios from "axios";
import "./Login.css";

export const MobileResponsiveModal = ({
  showMobileModal,
  setShowMobileModal,
}) => {
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);
  const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const assetPlanetClientName = "asset_planet_resource";
  const assetPlanetClientPassword = "a_p_creds";
  const basicCreds = Base64.btoa(
    assetPlanetClientName + ":" + assetPlanetClientPassword
  );

  const config = {
    headers: {
      "Content-type": "Application/json",
      Authorization: "Basic " + basicCreds,
    },
  };
  const handleSendEmail = async () => {
    if (!email) {
      message.error("Please enter your email address.");
      return;
    }

    if (!isValidEmail(email)) {
      message.error("Please enter a valid email address.");
      return;
    }

    setSending(true);

    try {
      const res = await axios.post(
        `${ROUTES.BASE_URL}/auth-service/auth/setup/dashboard`,
        { email },
        config
      );

      if (res && res.status === 200) {
        message.success("Email sent! Check your inbox to continue setup.");
        setShowEmailModal(false);
        setEmail("");
      } else {
        message.error("Something went wrong. Please try again later.");
      }
    } catch (error) {
      console.error("Email send error:", error);
      const errMsg =
        (error &&
          error.response &&
          error.response.data &&
          error.response.data.message) ||
        "Failed to send email. Please try again later.";
      message.error(errMsg);
    } finally {
      setSending(false);
    }
  };

  return (
    <React.Fragment>
      <Modal visible={showMobileModal} footer={null} closable={false} centered>
        <div className="text-center space-y-3">
          <div>
            <img width={64} height={64} src={dashboardIcon} alt="dekstop" />
          </div>
          <h3 className="modaltitle">Best Viewed on Desktop</h3>
          <p className="mobile-modal-details">
            For the best experience, we recommend setting up your profile on a
            desktop or laptop. Our platform is not yet optimized for mobile
            devices, and you may find it difficult to navigate.
          </p>
          <div className="mobile-modal-buttons-contaier">
            <button
              className="cancelbutton"
              onClick={() => setShowMobileModal(false)}
              style={{ width: "100%" }}
            >
              Continue on Mobile Anyway
            </button>
            <button
              className="savebutton"
              style={{ width: "100%" }}
              // onClick={() => {
              //   window.location.href =
              //     "mailto:support@assetplanet.com?subject=Send%20me%20a%20desktop%20login%20link";
              // }}
              onClick={() => {
                setShowMobileModal(false);
                setShowEmailModal(true);
              }}
            >
              Email Me a Link
            </button>
          </div>
        </div>
      </Modal>
      {/* Email Input Modal */}
      <Modal
        visible={showEmailModal}
        footer={null}
        closable
        centered
        onCancel={() => setShowEmailModal(false)}
      >
        <div className="text-center space-y-3">
          <h3 className="modaltitle">Enter Your Email Address</h3>
          <p className="mobile-modal-details">
            We’ll send you a quick link so you can continue setting up your
            profile later from your desktop or laptop.
          </p>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle" style={{ textAlign: "left" }}>
              Enter Email <span style={{ color: "red" }}>*</span>
            </h3>
            <input
              className="roleInput"
              placeholder="you@example.com"
              name="email"
              type="email"
              value={email}
              id="email"
              onChange={(e) => {
                e.preventDefault();
                e.persist();
                if (!isValidEmail(e.target.value)) {
                  if (e.target.value === "") {
                    setError(null);
                  } else {
                    setError("Email is invalid");
                  }
                } else {
                  setError(null);
                }
                setEmail(e.target.value);
              }}
            />
            {error && (
              <div
                style={{ color: "red", fontSize: "12px", textAlign: "left" }}
              >
                {error}
              </div>
            )}
          </div>

          <div className="mobile-modal-buttons-contaier">
            <button
              className="savebutton"
              style={{
                width: "100%",
                opacity: email ? "1" : "0.3",
                cursor: email ? "pointer" : "not-allowed",
                pointerEvents: email ? "" : "none",
              }}
              onClick={handleSendEmail}
              disabled={sending || !email}
            >
              {sending ? "Sending..." : "Send"}
            </button>
            <button
              className="cancelbutton"
              style={{ width: "100%" }}
              onClick={() => setShowEmailModal(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};
